import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton, Stack } from '@mui/material';

const emsName = `DPV2_CatalogEntryList_Empty`;

export const CatalogEntryListEmpty = () => (
	<ContentRecommendation
		id={emsName}
		properties={{
			emsName,
		}}
		loadingElement={
			<Stack>
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
				<Skeleton variant="rectangular" height={100} />
			</Stack>
		}
	/>
);
